export default "<ion-app>\n  <ion-router-outlet mode=\"ios\"></ion-router-outlet>\n</ion-app>\n";